import React from 'react'
import {MdArrowBack} from 'react-icons/md'
import ReactMarkdown from 'react-markdown'
import {getPublication_publication} from '@data/queries/website/__generated__/getPublication'
import {getWebsiteDefaultMenu_website} from '@data/queries/website/__generated__/getWebsiteDefaultMenu'
import useComponentWidth from '@hooks/useComponentWidth'
import useRef from '@hooks/useRef'
import Container from '@packages/justo-parts/lib/components/Container'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import Products from './Products'

import styles from './styles.module.css'

export interface PublicationProps {
  publication: getPublication_publication
  website: getWebsiteDefaultMenu_website
}

export default function Publication(props) {
  const {publication, website} = props
  const {t} = useTranslation('generic', {keyPrefix: 'fields'})
  const container = useRef()
  const width = useComponentWidth(container)

  if (!publication) {
    return (
      <Container size="small">
        <Link href="/" className={styles.link}>

          <MdArrowBack /> {t('goBack')}

        </Link>
      </Container>
    );
  }

  return (
    <div className={styles.container}>
      <Container size="small">
        <div ref={container}>
          <Link href="/" className={styles.link}>

            <MdArrowBack /> {t('goBack')}

          </Link>
        </div>
        <br />
        {publication.image ? (
          <div
            className={styles.image}
            style={{
              width,
              height: width * (2 / 3),
              backgroundImage: `url(${publication.image.url})`
            }}
          />
        ) : null}

        <br />
        <h1 className={styles.title}>{publication.title}</h1>
        <p className={styles.description}>{publication.description}</p>
        <div className={styles.content}>
          <ReactMarkdown source={publication.content} />
        </div>
        <Products publication={publication} menuId={website.defaultMenuId} />
      </Container>
    </div>
  );
}
